import { gql } from '@apollo/client';

export default gql`
  query findVoucherByReferenceAndMarket($reference: String!, $market: String, $channel: Channel, $voucherType: String) {
    findVoucherByReferenceAndMarket(reference: $reference, market: $market, channel: $channel, voucherType: $voucherType) {
      alias
      type
      amount
      currency
      validUntil
    }
  }
`;
